(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["jQuery"], factory);
	else if(typeof exports === 'object')
		exports["SpWhmcs"] = factory(require("jQuery"));
	else
		root["SpWhmcs"] = factory(root["jQuery"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__609__) {
return 